import React, { useEffect, useState } from "react";
import "./styles.scss";
import { ImageLazy } from "../imageLazy";

export type SwiperCard = {
  image: string;
  title?: string;
};

export interface AutoImageSwiperProps {
  cards: (SwiperCard | React.ReactNode)[];
  interval?: number;
  className?: string;
}

const AutoImageSwiperComponent: React.FC<AutoImageSwiperProps> = ({
  cards,
  interval = 6000,
  className = "",
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, interval);

    return () => clearInterval(timer);
  }, [cards.length, interval]);

  const renderCard = (card: SwiperCard | React.ReactNode, index: number) => {
    const isActive = index === activeIndex;

    return (
      <article
        key={index}
        className={`image-card ${isActive ? "active" : "inactive"}`}
      >
        {React.isValidElement(card) ? (
          card
        ) : typeof card === "object" && card !== null && "image" in card ? (
          <div className="legacy-card">
            <ImageLazy src={card.image} alt={card.title ?? ""} />
          </div>
        ) : null}
      </article>
    );
  };

  return (
    <section className={`image-swiper-container ${className}`}>
      {cards.map(renderCard)}
    </section>
  );
};

function areEqual(
  prev: AutoImageSwiperProps,
  next: AutoImageSwiperProps
): boolean {
  return (
    prev.interval === next.interval &&
    prev.className === next.className &&
    prev.cards === next.cards // comparação por referência para memo funcionar
  );
}

export const AutoImageSwiper = React.memo(AutoImageSwiperComponent, areEqual);
